import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { CalendarService } from 'src/app/service/calendar.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { NotificationService } from 'src/app/service/notification.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { Buttons } from 'src/app/home/table/Buttons';

@Component({
  selector: 'app-pending-users',
  templateUrl: './pending-users.component.html',
  styleUrls: ['./pending-users.component.css']
})
export class PendingUsersComponent implements OnInit {
  checked: boolean = false;
  userModel = new AddUser();
  userData: AddUser[] = [];

  comPlansUserData: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  salesChannels: string[] = [];
  commPlansData: string[] = [];
  userTypes: string[] = [];
  commPlans: string[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  calData: CalendarModel[];
  recentPendingUsers: AddUser[] = [];
  filteredUserData: AddUser[] = [];
  ordersTableColumns: TableColumn[];
  buttons: Buttons[] = [];
  columnsData: any;
  headder: string = 'Recent Pending Users (Last 30 Days)';
  pendingListView: 'recent' | 'all' = 'recent';
  pendingViewOptions = [
    { value: 'recent', label: 'Recent (Last 30 Days)' },
    { value: 'all', label: 'All Pending Users' }
  ];
  showAllPending = false;
  isLoadingPendingList = false;
  isLoadingMorePending = false;
  hasMorePending = false;
  pendingTotalCount = 0;
  pendingPageOffset = 0;
  private readonly pendingPageSize = 100;
  selectedUser: AddUser[] = [];
  selectedUserModel = new AddUser();

  constructor(private router: Router,
    private manageUserService: ManageUserService, private notificationService: NotificationService, private calendarService: CalendarService, private httpService: HttpClient) { }

  ngOnInit(): void {
    console.log("Inside pending users");
    //this.pendingUsers();
    this.userModel.commissionable = 'Y';
    this.getPrePopulatedUserData();
    this.loadRecentPendingUsers();   // ← THIS loads the bottom list
  }

  onPendingListViewChange(view: 'recent' | 'all'): void {
    if (view === 'all') {
      this.loadAllPendingUsers();
    } else {
      this.loadRecentPendingUsers();
    }
  }

  loadRecentPendingUsers() {
    this.pendingListView = 'recent';
    this.showAllPending = false;
    this.hasMorePending = false;
    this.pendingPageOffset = 0;
    this.pendingTotalCount = 0;
    this.headder = 'Recent Pending Users (Last 30 Days)';
    this.isLoadingPendingList = true;
    this.manageUserService.getRecentPendingUsers()
      .subscribe((data: AddUser[]) => {
        this.applyPendingListData(data);
        this.isLoadingPendingList = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.isLoadingPendingList = false;
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      });
  }

  loadAllPendingUsers() {
    this.pendingListView = 'all';
    this.showAllPending = true;
    this.pendingPageOffset = 0;
    this.pendingTotalCount = 0;
    this.hasMorePending = false;
    this.headder = 'All Pending Users';
    this.isLoadingPendingList = true;

    forkJoin({
      total: this.manageUserService.getPendingUsersCount(),
      page: this.manageUserService.getPendingUsersPage(this.pendingPageSize, 0)
    }).subscribe(
      ({ total, page }) => {
        this.pendingTotalCount = total;
        this.pendingPageOffset = page?.length || 0;
        this.applyPendingListData(page || []);
        this.hasMorePending = this.pendingPageOffset < this.pendingTotalCount;
        this.updateAllPendingHeader();
        this.isLoadingPendingList = false;
      },
      (errorResponse: HttpErrorResponse) => {
        this.isLoadingPendingList = false;
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      }
    );
  }

  loadMorePendingUsers(): void {
    if (!this.showAllPending || this.isLoadingMorePending || !this.hasMorePending) {
      return;
    }

    this.isLoadingMorePending = true;
    this.manageUserService.getPendingUsersPage(this.pendingPageSize, this.pendingPageOffset)
      .subscribe(
        (page: AddUser[]) => {
          const rows = page || [];
          this.pendingPageOffset += rows.length;
          this.applyPendingListData(rows, true);
          this.hasMorePending = this.pendingPageOffset < this.pendingTotalCount;
          this.updateAllPendingHeader();
          this.isLoadingMorePending = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.isLoadingMorePending = false;
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        }
      );
  }

  private toErrorMessage(error: HttpErrorResponse): string {
    return error?.error?.message || error?.message || 'Unexpected error';
  }

  private applyPendingListData(data: AddUser[], append = false): void {
    const normalized = this.normalizePendingRows(data);
    if (append) {
      this.recentPendingUsers = [...this.recentPendingUsers, ...normalized];
    } else {
      this.recentPendingUsers = normalized;
      this.selectedUser = [];
    }
    this.filteredUserData = [...this.recentPendingUsers];
    if (!this.ordersTableColumns?.length) {
      this.initializePendingColumns();
    }
  }

  private normalizePendingRows(data: AddUser[]): AddUser[] {
    return (data || []).map(user => {
      if (user.first_name && user.last_name) {
        user.name = `${user.last_name}, ${user.first_name}`;
      }
      user.effective_date = this.formatEffectiveDate(user.effective_date);
      return user;
    });
  }

  private formatEffectiveDate(dateInput: any): string {
    if (!dateInput) {
      return '';
    }

    if (typeof dateInput === 'string') {
      const alreadyFormatted = dateInput.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (alreadyFormatted) {
        return dateInput;
      }

      const isoDateOnly = dateInput.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDateOnly) {
        return `${isoDateOnly[2]}-${isoDateOnly[3]}-${isoDateOnly[1]}`;
      }
    }

    const parsed = new Date(dateInput);
    if (isNaN(parsed.getTime())) {
      return dateInput;
    }

    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    const year = parsed.getFullYear();
    return `${month}-${day}-${year}`;
  }

  private updateAllPendingHeader(): void {
    if (!this.showAllPending) {
      return;
    }
    if (this.pendingTotalCount > 0) {
      this.headder = `All Pending Users (${this.filteredUserData.length} of ${this.pendingTotalCount})`;
    } else {
      this.headder = 'All Pending Users';
    }
  }

  initializePendingColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.PendingUsers;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.buttons = [
      {
        name: 'Update User',
        pagenavigation: 'add-users'
      },
      {
        name: 'Create New User',
        pagenavigation: 'new-users'
      }
    ];
  }

  redirectToUpdateUser(url: string) {
    if (url === 'new-users') {
      this.goToCreateNewUser();
      return;
    }
    if (url !== 'add-users') {
      return;
    }
    if (this.selectedUser.length !== 1) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please select only one user");
      return;
    }

    this.selectedUserModel = this.selectedUser[0];
    if (this.selectedUserModel.comm_plan_id != null) {
      const planData = this.manageUserService.comPlansUserData.filter(
        com => com.comm_plan_id == this.selectedUserModel.comm_plan_id
      );
      this.selectedUserModel.commission_plan = planData.length > 0
        ? planData[0].commission_plan
        : "N/A";
    } else {
      this.selectedUserModel.commission_plan = "N/A";
    }
    if (!this.selectedUserModel.supervisor_name) {
      this.selectedUserModel.supervisor_name = "N/A";
    }

    this.manageUserService.selectedUserModel = this.selectedUserModel;
    this.router.navigate(['/add-users'], { queryParams: { page: 'pending-users' } });
  }

  update(user: any, values: any) {
    if (values.value.currentTarget.checked) {
      this.selectedUser.push(user.row);
    } else {
      this.selectedUser.forEach((value: any, index: any) => {
        if (value.id == user.row.id) {
          this.selectedUser.splice(index, 1);
        }
      });
    }
    this.manageUserService.selectedUserModel = this.selectedUser[0];
    this.manageUserService.selectedUserDocModel = this.selectedUser;
  }

  selectAll(values: any) {
    if (values.value.currentTarget.checked) {
      this.selectedUser = [...this.filteredUserData];
    } else {
      this.selectedUser = [];
    }
    this.manageUserService.selectedUserModel = this.selectedUser[0];
    this.manageUserService.selectedUserDocModel = this.selectedUser;
  }

  goToCreateNewUser() {
    this.router.navigate(['/new-users'], { queryParams: { page: 'newUser' } });
  }

  profileSearch() {
    console.log("first_name = " + this.userModel.first_name);
    let status = 0;
    if (this.userModel.first_name) {
      console.log("Inside first_name");
      status = 1;
    } else if (this.userModel.last_name) {
      console.log("Inside last_name");
      status = 1;
    } else if (this.userModel.employeeId) {
      console.log("Inside employeeId");
      status = 1;
    } else if (this.userModel.id) {
      console.log("Inside id");
      status = 1;
    } else {
      status = 0;
    }
    console.log("status = " + status);
    if (status == 0) {
      //this.uprofileData = [];
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
    } else {
      this.redirect('search-users');
    }
  }

  redirect(url: string) {
    console.log("Inside pending users redirect");
    console.log(this.userModel);
    this.manageUserService.userModel = this.userModel;
    if (this.userModel.first_name != null || this.userModel.last_name != null || this.userModel.employeeId != null ||
      this.userModel.id != null || this.userModel.supervisor_id != null || this.userModel.user_type != null ||
      this.userModel.sales_rep_channel != null || this.userModel.comm_plan_id != null
      || this.userModel.payroll_start_date != null) {
      this.router.navigate(['/' + url], { queryParams: { page: 'pending-users', returnTo: 'pending-users' } });
    } else {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
    }
    //this.router.navigate(['/'+url],{ queryParams: { page: 'pending-users' } });
  }

  public pendingUsers() {
    this.manageUserService.getPendingUsers()
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        console.log(this.userData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  checkUncheckAll() {
    if (!this.checked) {
      this.checked = true;
      console.log("in if :", this.checked)
    }
    else {
      this.checked = false
      console.log("in else :", this.checked)
    }

  }

  getPrePopulatedUserData() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {

      this.userData = data;
      //console.log(this.userData);
      for (let userInfo of this.userData) {
        if (userInfo.sales_rep_channel != null) {
          this.salesChnlsUserData.push(userInfo);
          this.salesChannels.push(userInfo.sales_rep_channel);
          if (this.salesChannels.length > 1) {
            this.salesChannels.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.user_type != null) {
          this.userTypes.push(userInfo.user_type)
          if (this.userTypes.length > 1) {
            this.userTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.commission_plan != null) {
          this.comPlansUserData.push(userInfo);
        } else if (userInfo.sales_rep_type != null) {
          this.salesRepTypes.push(userInfo.sales_rep_type);
          if (this.salesRepTypes.length > 1) {
            this.salesRepTypes.sort((a, b) =>
              a.localeCompare(b));
          }

        } else if (userInfo.calendar_type != null) {
          this.payrollCalender.push(userInfo.calendar_type);
          if (this.payrollCalender.length > 1) {
            this.payrollCalender.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }
      //console.log("userdata===", JSON.stringify(this.comPlansUserData), " user type ", this.userTypes);
      this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
      this.manageUserService.userTypes = this.userTypes;
      this.manageUserService.allComPlansUserData = this.comPlansUserData;
      this.manageUserService.comPlansUserData = this.comPlansUserData;
      this.manageUserService.salesRepTypes = this.salesRepTypes;
      this.manageUserService.payrollCalender = this.payrollCalender;
      // this.filterUserTypes();
      // this.filterSalesChannels();
      // this.filterCommStr();
      this.getCalData();
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getCalData() {
    this.calendarService.getCalData().subscribe(
      (response: CalendarModel[]) => {
        this.calData = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

}
